import Button from "../../components/buttons/button";
import { FiAlertTriangle } from "react-icons/fi";

const DeleteProduct = ({ t, setOpen }) => {
  return (
    <div className="space-y-4">
      <span className="grid rounded-full w-11 mx-auto  size-11 place-content-center bg-[#FFEEEC]">
        <FiAlertTriangle size={28} className="text-[#902929]" />
      </span>
      <p className="text-xl font-bold text-center">{t("areUSureToDeleteProduct")}</p>
      <div className="font-medium text-center text-mainGray">
        <p>{t("productCantBeRestored")}</p>
      </div>
      <div className="flex items-center justify-center gap-2">
        <Button
          className={"bg-[#902929]"}
          type={"button"}
          onClick={() => setOpen(false)}
        >
          {t("delete")}
        </Button>
        <Button className="mainLinear" onClick={() => setOpen(false)}>
          {t("cancel")}
        </Button>
      </div>
    </div>
  );
};

export default DeleteProduct;
